import { CheckboxGroup } from "../../core/components/CheckboxGroup";
import { SelectAllButton } from "../../core/components/SelectAllButton";
import { Field, useField } from 'formik';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { Checkbox } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommunicationRolesField = _ref => {
  let {
    name
  } = _ref;
  const [{
    value
  }, {
    error,
    touched
  }, {
    setValue
  }] = useField(name);
  return /*#__PURE__*/_jsx(CheckboxGroup, {
    $minWidth: "120u",
    checkboxesContainerProps: {
      $pt: '2u'
    },
    error: touched && error,
    label: "Roles",
    toolbar: /*#__PURE__*/_jsx(SelectAllButton, {
      areAllSelected: value.length === Object.keys(UserRole).length,
      onDeselectAllClick: () => setValue([]),
      onSelectAllClick: () => setValue(Object.values(UserRole))
    }),
    "data-sentry-element": "CheckboxGroup",
    "data-sentry-component": "CommunicationRolesField",
    "data-sentry-source-file": "CommunicationRolesField.tsx",
    children: Object.keys(UserRole).map(key => /*#__PURE__*/_jsx(Field, {
      $height: "24u",
      as: Checkbox,
      checked: value.includes(UserRole[key]),
      label: key,
      name: "roles",
      value: UserRole[key]
    }, UserRole[key]))
  });
};